import { useQuery } from '@tanstack/react-query';
import { getMcpKeyAdministration } from '@/apps/apis/mcpAccess';

/**
 * Asks the Facade whether the signed-in person may manage other people's MCP keys. It reads their roles from
 * the identity provider now; the sign-in token's permissions can be an hour stale.
 */
export const useMcpKeyAdministration = () =>
  useQuery({ queryKey: ['mcpAccess', 'administration'], queryFn: getMcpKeyAdministration, staleTime: 0 });
